import type { SlideDef } from "@/engine/types";
import { RecapSlide } from "./01-recap";
import { NextStepsSlide } from "./02-next-steps";
import { GlossarySlide } from "./03-glossary";
import { CloseSlide } from "./04-close";

export const slides: SlideDef[] = [
  {
    id: "c7-recap",
    chapter: 7,
    title: "Recap: what you covered",
    component: RecapSlide,
  },
  {
    id: "c7-next-steps",
    chapter: 7,
    title: "Next steps after this block",
    component: NextStepsSlide,
  },
  {
    id: "c7-glossary",
    chapter: 7,
    title: "Quick glossary",
    component: GlossarySlide,
  },
  {
    id: "c7-close",
    chapter: 7,
    title: "End of SEO — Beginner",
    component: CloseSlide,
  },
];
